import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from '@/pages/LandingPage';
import Login from '@/pages/Login';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import VerifyEmail from '@/pages/VerifyEmail';
import RegisterClient from '@/pages/RegisterClient';
import RegisterCompany from '@/pages/RegisterCompany';
import PaymentCallback from '@/pages/PaymentCallback';
import ClientDashboard from '@/pages/ClientDashboard';
import ClientRequests from '@/pages/ClientRequests';
import ClientRequestDetail from '@/pages/ClientRequestDetail';
import NewRequest from '@/pages/NewRequest';
import CompanyDashboard from '@/pages/CompanyDashboard';
import CompanySubscription from '@/pages/CompanySubscription';
import CompanyRequests from '@/pages/CompanyRequests';
import CompanySettings from '@/pages/CompanySettings';
import ClientSettings from '@/pages/ClientSettings';
import AdminDashboard from '@/pages/AdminDashboard';
import TermsConditions from '@/pages/TermsConditions';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import { AuthProvider } from '@/auth';
import { LanguageProvider } from '@/contexts/LanguageContext';
import CookieBanner from '@/components/CookieBanner';
import SplashScreen from '@/components/SplashScreen';
import '@/App.css';

function App(){
  const [showSplash, setShowSplash] = useState(() => {
    // Show splash only on first visit in this session
    const hasSeenSplash = sessionStorage.getItem('servicego_splash_shown');
    return !hasSeenSplash;
  });

  const handleSplashComplete = () => {
    sessionStorage.setItem('servicego_splash_shown', 'true');
    setShowSplash(false);
  };

  if (showSplash) {
    return <SplashScreen onComplete={handleSplashComplete} />;
  }

  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/cliente/registrazione" element={<RegisterClient />} />
            <Route path="/ditta/registrazione" element={<RegisterCompany />} />
            <Route path="/ditta/payment-callback" element={<PaymentCallback />} />
            <Route path="/cliente/dashboard" element={<ClientDashboard />} />
            <Route path="/cliente/richieste" element={<ClientRequests />} />
            <Route path="/cliente/richieste/:id" element={<ClientRequestDetail />} />
            <Route path="/cliente/nuova" element={<NewRequest />} />
            <Route path="/ditta/dashboard" element={<CompanyDashboard />} />
            <Route path="/ditta/abbonamento" element={<CompanySubscription />} />
            <Route path="/ditta/richieste" element={<CompanyRequests />} />
            <Route path="/ditta/impostazioni" element={<CompanySettings />} />
            <Route path="/cliente/impostazioni" element={<ClientSettings />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/termini" element={<TermsConditions />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
